import React from 'react'
import { useDispatch } from 'react-redux'
import { Form, Input } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { changePassword } from 'store/actions/profile'
import { ReactComponent as PasswordIcon } from 'assets/svg/login/main_password.svg'
import { useTranslation } from 'react-i18next'

export const ChangePasswordForm = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const initialValues = {
        old_password: null,
        password: null,
        password_confirmation: null
    }

    const validationSchema = yup.object().shape({
        old_password: yup.string().nullable().required(t('field_required')),
        password: yup
            .string()
            .nullable()
            .required(t('field_required'))
            .matches(/^\S*(?=\S*[a-z])\S*$/, t('password_validation.lowercase'))
            .matches(/^\S*(?=\S*[A-Z])\S*$/, t('password_validation.uppercase'))
            .matches(/^\S*(?=\S*[\d])\S*$/, t('password_validation.digit'))
            .matches(/^.{8,}$/, t('password_validation.length')),
        password_confirmation: yup
            .string()
            .nullable()
            .required(t('field_required'))
            .oneOf([yup.ref('password'), null], t('password_validation.confirmation'))
    })

    function onSubmit(values) {
        dispatch(changePassword({ values }))
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
                <>
                    <div className="account__form">
                        <div className="account__white-box border-top-0">
                            <Form.Item
                                className="account__form-item"
                                validateStatus={errors.old_password ? 'error' : null}
                            >
                                <Input
                                    name="old_password"
                                    value={values.old_password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="app__input"
                                    placeholder={t('old_pass_ph')}
                                    type="password"
                                    prefix={<PasswordIcon />}
                                />
                                {errors.old_password && touched.old_password && (
                                    <p className="account__form-error">{errors.old_password}</p>
                                )}
                            </Form.Item>
                            <Form.Item className="account__form-item" validateStatus={errors.password ? 'error' : null}>
                                <Input
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="app__input"
                                    placeholder={t('new_pass_ph')}
                                    type="password"
                                    prefix={<PasswordIcon />}
                                />
                                {errors.password && touched.password && (
                                    <p className="account__form-error">{errors.password}</p>
                                )}
                            </Form.Item>
                            <Form.Item
                                className="account__form-item"
                                validateStatus={errors.password_confirmation ? 'error' : null}
                            >
                                <Input
                                    name="password_confirmation"
                                    value={values.password_confirmation}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="app__input"
                                    placeholder={t('confirm_pass_ph')}
                                    type="password"
                                    prefix={<PasswordIcon />}
                                />
                                {errors.password_confirmation && touched.password_confirmation && (
                                    <p className="account__form-error">{errors.password_confirmation}</p>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="account__buttons">
                        <button type="button" onClick={handleSubmit} className="account__buttons__submit">
                            {t('update')}
                        </button>
                    </div>
                </>
            )}
        </Formik>
    )
}
